import {createContext, useState} from 'react';

export const CreateOrJoinTeamContext = createContext({})

export const CreateOrJoinTeamContextProvider = ({children}) => {
    const [status, setStatus] = useState('checking')
    return <CreateOrJoinTeamContext.Provider value={{status, setStatus}}>
        {children}
    </CreateOrJoinTeamContext.Provider>
}